import { render, staticRenderFns } from "./couponDefault.vue?vue&type=template&id=c4dc77b2&scoped=true&"
import script from "./couponDefault.vue?vue&type=script&lang=js&"
export * from "./couponDefault.vue?vue&type=script&lang=js&"
import style0 from "./couponDefault.vue?vue&type=style&index=0&id=c4dc77b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4dc77b2",
  null
  
)

export default component.exports